/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Oct 2021
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import styles from './Header.module.css';
import backImg from '../../../../assets/images/Fireboard/back2_red.png';
import constants from '../../../../globalization';
import Button from '../../../../components/Button';

const Header = props => {
  const {
    goBack,
    selectedSensorGrpId,
    sensorGroupsList,
    onChangeSensorGroup,
    openQRCodeScanner,
    onChangeInput,
    sensorName,
    searchKey,
  } = props;

  return (
    <div className={styles.headerWrapper}>
      <img src={backImg} className={styles.backArrow} onClick={goBack} alt='back' />
      <input
        type='text'
        value={searchKey}
        onChange={onChangeInput('searchSensor')}
        placeholder={'Search here'}
        className={styles.input} />
      <span className={styles.heading}>{constants.namedSensors}</span>
      <input
        type='text'
        value={sensorName}
        onChange={onChangeInput('sensorName')}
        placeholder={'Name'}
        className={styles.input} />
      <select className={styles.select} value={selectedSensorGrpId} onChange={onChangeSensorGroup}>
        {sensorGroupsList.map(sensorGrp =>
          <option
            key={sensorGrp.id}
            value={sensorGrp.id}
            selected={sensorGrp.id === selectedSensorGrpId}>
            {sensorGrp.name}
          </option>
        )}
      </select>
      <Button
        className={styles.button}
        disabled={String(sensorName).trim().length === 0}
        onClick={openQRCodeScanner}>
        <span className={styles.buttonText}>{constants.registerSensor.toUpperCase()}</span>
      </Button>
    </div>
  );
};

export default Header;

Header.propTypes = {
  goBack: PropTypes.func,
  selectedSensorGrpId: PropTypes.any,
  sensorGroupsList: PropTypes.array,
  onChangeSensorGroup: PropTypes.func,
  openQRCodeScanner: PropTypes.func,
  onChangeInput: PropTypes.func,
  sensorName: PropTypes.string,
  searchKey: PropTypes.string,
};

Header.defaultProps = {
  goBack: () => { },
  sensorGroupsList: [],
  onChangeSensorGroup: () => { },
  openQRCodeScanner: () => { },
  onChangeInput: () => { },
  sensorName: '',
  searchKey: '',
};
